import React from "react";
import { FormProvider } from "react-hook-form";
import CustomDialog from "../../../components/dialog";
import { RHFTextField } from "../../../components/hook-form";
import RFHdatePicker from "../../../components/hook-form/RHFDatePicker";
import { RHFSelect } from "../../../components/hook-form/RHFSelect";
import { MenuItem } from "@mui/material";

const CreateSeasonForm = ({
  methods,
  control,
  onSubmit,
  loading,
  setCreateSeason,
  themes,
  fields,
  watch,
  filteredThemes,
  handleSubmit,
  isEdit = false
  // calculateWeekEndDate,
}) => {

  return (
    <FormProvider {...methods} control={control}>
      <form
        id="feedbackForm"
        className="feedback-form"
        onSubmit={handleSubmit(onSubmit)}>
        <CustomDialog
          open={true}
          onClose={() => setCreateSeason(false)}
          title={isEdit ? "Edit Season" : "Add Season"}
          buttonTxt={isEdit ? "Update" : "Submit"}
          fullWidth={true}
          disabled={loading}
          handleClose={() => {
            methods.reset();
            setCreateSeason(false);
          }}
          handleSubmit={handleSubmit(onSubmit)}
          width={587}>
          <p className="season-label-text">Name</p>
          <RHFTextField name={"season_name"} />
          <p className="season-label-text mt-4">
            Start Date{" "}
            <span className="grey_text">
              Has to be a Monday & more than one week in the future
            </span>
          </p>
          <RFHdatePicker name={"start_date"} disabled={isEdit} />
          <p className="season-label-text mt-4">
            # of weeks for season games
            <span className="grey_text">+ 2 weeks for playoff and finals </span>
          </p>
          <RHFTextField
            name={"weeks_for_season_games"}
            className="no_of_weeks_input"
            type="number"
            disabled={isEdit}
          />
          {watch("start_date") && fields.length > 0 && (
            <div>
              <p className="season-label-text mt-4">
                Theme
                <span className="grey_text">
                  Themes can only be changed 7 days before the start
                </span>
              </p>

              <div className="week-select-container">
                {fields?.map((field, index, array) => {
                  // const weekEndDate = calculateWeekEndDate(
                  //   watch("start_date"),
                  //   index + 1
                  // );
                  // const availableThemes = filteredThemes(weekEndDate);

                  return (
                    <div key={field.id} style={{ width: "48%" }}>
                      <RHFSelect
                        name={`week.${index}.theme_id`}
                        placeholder={`${array.length - 2 <= index
                          ? array.length - 1 <= index
                            ? "Final"
                            : "Semifinals"
                          : `Week ${index + 1}`
                          }`}>
                        {filteredThemes.map((item, idx) => (
                          <MenuItem key={idx} value={item.theme_id}>
                            {item.theme_name}
                          </MenuItem>
                        ))}
                        {filteredThemes.length === 0 && (
                          <MenuItem value={null}>No themes available</MenuItem>
                        )}
                      </RHFSelect>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </CustomDialog>
      </form>
    </FormProvider>
  );
};

export default CreateSeasonForm;
